import type { Trade } from "../types/trade";

/** Backend/product tags for ingest provenance */
export type TradeDataProvenanceKind = "csv-import" | "broker-sync";

/**
 * Whether the trade came from CSV import vs live broker API sync.
 * Prefer tags when present; otherwise use `broker_synced` from the API.
 */
export function getTradeDataProvenance(
  trade: Pick<Trade, "tags" | "broker_synced">
): { label: string; kind: TradeDataProvenanceKind } | null {
  const tags = trade.tags || [];
  const normalized = new Set(tags.map((t) => String(t).trim().toLowerCase()));

  if (normalized.has("csv-import")) {
    return { label: "Trade import", kind: "csv-import" };
  }
  if (normalized.has("broker-sync")) {
    return { label: "Broker sync", kind: "broker-sync" };
  }

  if (trade.broker_synced === true) {
    return { label: "Broker sync", kind: "broker-sync" };
  }
  if (trade.broker_synced === false) {
    return { label: "Trade import", kind: "csv-import" };
  }

  return null;
}
